import { Text } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { formatTimeStamp } from 'utilities/transcriptList';

import { selectVideoDuration } from 'selectors/videoPlayer';

import { selectTranscriptSearchPhrase } from '../../../../selectors/shareVideo';
import { replaceSearchWordsInPhrase } from '../../../../utilities/transcript/findSearchWordInTranscript';

import styles from '../styles.module.less';

const RenderRowAtIndex = ({
  index,
  currentIndex,
  style,
  setRowHeight,
  phrases,
  handleRowClick,
  hasStarted,
  csIndex,
  counter,
}) => {
  const { ts: currentRowTs, value: currentRowValue } = phrases[index];
  const rowRef = useRef(null);
  const [isCurrentTs, setIsCurrentTs] = useState(currentIndex === index);
  const duration = useSelector(selectVideoDuration);
  const searchPhrase = useSelector(selectTranscriptSearchPhrase);

  const activeIndex = index === csIndex ? counter : -1;
  const baseClass =
    searchPhrase.length > 0 ? `${styles.highlightSearchWord}` : '';

  const activeClass = styles.active;

  const currentRowValueAdjusted = replaceSearchWordsInPhrase(
    currentRowValue,
    searchPhrase,
    baseClass,
    activeClass,
    activeIndex
  );

  const classBasedOnIndex = () => {
    if (index === 0) {
      return styles.marginTop;
    }

    if (index === phrases.length - 1) {
      return styles.marginBottom;
    }

    return '';
  };

  /* eslint-disable no-unused-vars */
  // ignore the height unused var that we pull out of style
  const { height, ...styleWithoutHeight } = style;
  /* eslint-enable no-unused-vars */

  useEffect(() => {
    setIsCurrentTs(currentIndex === index);
  }, [currentIndex, index]);

  useEffect(() => {
    if (rowRef.current) {
      setRowHeight(index, rowRef.current.clientHeight);
    }
  }, [index, setRowHeight]);

  return (
    <div
      style={styleWithoutHeight}
      className={classNames(styles.container)}
      onMouseUp={() => {
        handleRowClick(index);
      }}
      ref={rowRef}
      data-testid={`transcript-row-${index}`}
    >
      <div
        className={classNames(
          styles.row,
          hasStarted && isCurrentTs && styles.highlight,
          classBasedOnIndex()
        )}
      >
        <div className={styles.timestamp}>
          <Text size="small" color="blurple">
            {formatTimeStamp(currentRowTs, duration)}
          </Text>
        </div>
        <div className={styles.transcript}>
          <Text>
            <div
              dangerouslySetInnerHTML={{ __html: currentRowValueAdjusted }}
            ></div>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default RenderRowAtIndex;
